class SFError extends Error {
  constructor(
    { status = "700", code = "Internal", message = "Unknown", wgCode = "xxxx" },
    ...params
  ) {
    super(...params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SFError);
    }
    this.name = "CustomError";
    this.status = status;
    this.code = code;
    this.message = message;
    this.wgCode = wgCode;
    return;
  }

  json() {
    return {
      error: true,
      status: this.status,
      code: this.code,
      message: this.message,
      wgCode: this.wgCode,
    };
  }
}

export default SFError;
